(function () {
  var RE = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|shorts\/|[?&]v=)([^#&?]{11}).*/;

  function extractId(url) {
    if (!url) return null;
    var m = String(url).trim().match(RE);
    return m ? m[1] : null;
  }

  function render(block) {
    var input = block.querySelector('.yt-input');
    var preview = block.querySelector('.yt-preview');
    if (!input || !preview) return;

    var id = extractId(input.value);
    if (!id) { preview.hidden = true; preview.innerHTML = ''; return; }

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id;
    iframe.className = 'w-100 h-100 border-0 rounded-4';
    iframe.title = 'YouTube video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    preview.innerHTML = '';
    preview.appendChild(iframe);
    preview.hidden = false;
  }

  function findClosest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(sel) : el.msMatchesSelector && el.msMatchesSelector(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  // พิมพ์/วางลิงก์แล้วอัปเดตพรีวิว (debounce เล็กน้อย)
  document.addEventListener('input', function (e) {
    var input = findClosest(e.target, '.yt-input');
    if (!input) return;
    var block = findClosest(input, '[data-yt-block]');
    if (block._ytTimer) clearTimeout(block._ytTimer);
    block._ytTimer = setTimeout(function(){ render(block); }, 300);
  });

  // โหลดหน้ามา ถ้ามีค่าใน input จาก DB แล้วให้แสดงเลย
  document.addEventListener('DOMContentLoaded', function () {
    var blocks = document.querySelectorAll('[data-yt-block]');
    for (var i=0; i<blocks.length; i++) render(blocks[i]);
  });
})();

export function initYouTubePreview() {
  document.querySelectorAll('[data-yt-block]').forEach(function(block) {
    var input = block.querySelector('.yt-input');
    var preview = block.querySelector('.yt-preview');
    if (!input || !preview) return;

    var RE = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|shorts\/|[?&]v=)([^#&?]{11}).*/;
    var m = String(input.value || '').trim().match(RE);
    var id = m ? m[1] : null;

    if (!id) { preview.hidden = true; preview.innerHTML = ''; return; }

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id;
    iframe.className = 'w-100 h-100 border-0 rounded-4';
    iframe.title = 'YouTube video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    preview.innerHTML = '';
    preview.appendChild(iframe);
    preview.hidden = false;
  });
}

